module.exports = __webpack_public_path__ + "img/icon-quote.b69131fa.svg";